import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type ItineraryPackageLoaderConfig } from '@itinerary/types';

export enum VehicleType {
    Plane = 'plane',
    Train = 'train',
    Bus = 'bus',
    Taxi = 'taxi',
}

export type VehicleInfo = {
    title: string;
    type: string;
    code?: string;
    description?: string;
};

export type CorporationInfo = {
    logoUrl: string;
    logoFallbackUrl: string;
    title: string;
    subTitle?: string;
    code: string;
};

export interface VehicleImage {
    alt: string;
    urls: {
        thumbnail: string;
        small: string;
        original: string;
    };
}

export enum TripInfoComponent {
    BusSeatsSmall = 'BusSeatsSmall',
    PackageInfo = 'PackageInfo',
    CancellationTerms = 'CancellationTerms',
    TrainMidStations = 'TrainMidStations',
    HotelInfo = 'HotelInfo',
    ExtraTerms = 'ExtraTerms',
}

export type TripPackageDetails = {
    title: string;
    component: TripInfoComponent;
};

export type SegmentOption = {
    title: string;
    icon?: IconDefinition;
    loading?: boolean;
};

export type Facilities = {
    title: string;
    list: {
        title: string;
        check: boolean;
    }[];
};

export type TechnicalStop = {
    message: string;
};

export interface TripPackageLoaderConfig extends ItineraryPackageLoaderConfig {
    totalSeatCount: number;
    originCode: string;
    destinationCode: string;
    originName?: string;
    destinationName?: string;
    date: Date;
}

export enum CapacityTextStatus {
    'low' = 'low',
    normal = 'normal',
}
